function clampWidgetValue(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

window.coreAIChatWidgetBehavior = window.coreAIChatWidgetBehavior || function () {
    function parsePixelValue(value) {
        if (typeof value === 'number' && Number.isFinite(value)) {
            return value;
        }

        if (typeof value !== 'string') {
            return null;
        }

        var parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : null;
    }

    function attach(app, config) {
        if (!app || app.__aiChatWidgetAttached) {
            return;
        }

        app.__aiChatWidgetAttached = true;
        app.chatWidgetStateName = null;
        app.chatWidgetStateSession = null;
        app.chatWidgetStateDocuments = null;
        app.chatWidgetLayoutKey = null;
        app.chatHistorySection = null;
        app.widgetContainerElement = null;
        app.widgetToggleButtonElement = null;
        app.widgetResetSizeButtonElement = null;
        app.widgetResizeObserver = null;
        app.widgetViewportResizeHandler = null;
        app.widgetDefaultWidth = null;
        app.widgetDefaultHeight = null;
        app.widgetIsInitialized = false;

        app.getStoredWidgetLayout = function () {
            if (!this.chatWidgetLayoutKey || !config.widget.persistLayout) {
                return {};
            }

            try {
                var storedLayout = localStorage.getItem(this.chatWidgetLayoutKey);
                return storedLayout ? JSON.parse(storedLayout) || {} : {};
            }
            catch (error) {
                console.warn('Failed to read widget layout state.', error);
                return {};
            }
        };

        app.saveStoredWidgetLayout = function (partialLayout) {
            if (!this.chatWidgetLayoutKey || !config.widget.persistLayout) {
                return;
            }

            var currentLayout = this.getStoredWidgetLayout();
            var nextLayout = Object.assign({}, currentLayout);

            if (partialLayout.panel !== undefined) {
                nextLayout.panel = Object.assign({}, currentLayout.panel || {}, partialLayout.panel || {});
            }

            if (partialLayout.position !== undefined) {
                nextLayout.position = Object.assign({}, currentLayout.position || {}, partialLayout.position || {});
            }

            localStorage.setItem(this.chatWidgetLayoutKey, JSON.stringify(nextLayout));
        };

        app.getElementSize = function (element, fallbackWidth, fallbackHeight) {
            if (!element) {
                return {
                    width: fallbackWidth || 0,
                    height: fallbackHeight || 0
                };
            }

            var rect = element.getBoundingClientRect();
            var computed = window.getComputedStyle(element);

            return {
                width: Math.round(rect.width || parsePixelValue(computed.width) || fallbackWidth || 0),
                height: Math.round(rect.height || parsePixelValue(computed.height) || fallbackHeight || 0)
            };
        };

        app.getElementPosition = function (element) {
            if (!element) {
                return {
                    left: 0,
                    top: 0
                };
            }

            var rect = element.getBoundingClientRect();
            var computed = window.getComputedStyle(element);
            var inlineLeft = parsePixelValue(element.style.left);
            var inlineTop = parsePixelValue(element.style.top);
            var computedLeft = parsePixelValue(computed.left);
            var computedTop = parsePixelValue(computed.top);
            var isHidden = computed.display === 'none';

            return {
                left: Math.round(isHidden && Number.isFinite(inlineLeft) ? inlineLeft : rect.left || inlineLeft || computedLeft || 0),
                top: Math.round(isHidden && Number.isFinite(inlineTop) ? inlineTop : rect.top || inlineTop || computedTop || 0)
            };
        };

        app.getAvailableWidgetPositionRange = function (width, height) {
            var viewportPadding = 8;
            return {
                padding: viewportPadding,
                maxLeft: Math.max(viewportPadding, window.innerWidth - width - viewportPadding),
                maxTop: Math.max(viewportPadding, window.innerHeight - height - viewportPadding)
            };
        };

        app.createStoredPosition = function (left, top, width, height) {
            var range = this.getAvailableWidgetPositionRange(width, height);
            var leftSpan = Math.max(0, range.maxLeft - range.padding);
            var topSpan = Math.max(0, range.maxTop - range.padding);

            return {
                left: Math.round(left),
                top: Math.round(top),
                leftRatio: leftSpan === 0 ? 0 : (left - range.padding) / leftSpan,
                topRatio: topSpan === 0 ? 0 : (top - range.padding) / topSpan
            };
        };

        app.resolveStoredPosition = function (storedPosition, width, height) {
            if (!storedPosition) {
                return null;
            }

            var range = this.getAvailableWidgetPositionRange(width, height);
            var left = Number(storedPosition.left);
            var top = Number(storedPosition.top);
            var leftRatio = Number(storedPosition.leftRatio);
            var topRatio = Number(storedPosition.topRatio);

            if (Number.isFinite(leftRatio)) {
                left = range.padding + Math.max(0, range.maxLeft - range.padding) * leftRatio;
            }

            if (Number.isFinite(topRatio)) {
                top = range.padding + Math.max(0, range.maxTop - range.padding) * topRatio;
            }

            if (!Number.isFinite(left) || !Number.isFinite(top)) {
                return null;
            }

            return this.clampWidgetPosition(left, top, width, height);
        };

        app.clampWidgetPosition = function (left, top, width, height) {
            var range = this.getAvailableWidgetPositionRange(width, height);

                return {
                left: Math.round(clampWidgetValue(left, range.padding, range.maxLeft)),
                top: Math.round(clampWidgetValue(top, range.padding, range.maxTop))
            };
        };

        app.getStoredWidgetDocuments = function () {
            this.clearStoredWidgetDocuments();
            return [];
        };

        app.saveStoredWidgetDocuments = function () {
            this.clearStoredWidgetDocuments();
        };

        app.clearStoredWidgetDocuments = function () {
            if (!this.chatWidgetStateDocuments) {
                return;
            }

            localStorage.removeItem(this.chatWidgetStateDocuments);
        };

        app.applyAbsolutePosition = function (element, left, top) {
            if (!element) {
                return;
            }

            element.style.left = left + 'px';
            element.style.top = top + 'px';
            element.style.right = 'auto';
            element.style.bottom = 'auto';
        };

        app.getWidgetDefaultSize = function () {
            return {
                width: this.widgetDefaultWidth || parsePixelValue(config.widget.defaultWidth) || 380,
                height: this.widgetDefaultHeight || parsePixelValue(config.widget.defaultHeight) || 520
            };
        };

        app.getWidgetToggleGap = function () {
            return 8;
        };

        app.isWidgetPanelVisible = function () {
            if (!this.widgetContainerElement) {
                return false;
            }

            var computed = window.getComputedStyle(this.widgetContainerElement);
            return this.widgetContainerElement.classList.contains('open') && computed.display !== 'none';
        };

        app.persistWidgetPanelPosition = function () {
            if (!this.widgetContainerElement || !config.widget.persistLayout) {
                return;
            }

            var panelDefaultSize = this.getWidgetDefaultSize();
            var panelPosition = this.getElementPosition(this.widgetContainerElement);
            var panelSize = this.getElementSize(this.widgetContainerElement, panelDefaultSize.width, panelDefaultSize.height);
            var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
            var linkedPosition = this.clampWidgetPosition(
                panelPosition.left + panelSize.width - toggleSize.width,
                panelPosition.top + panelSize.height + this.getWidgetToggleGap(),
                toggleSize.width,
                toggleSize.height);

            this.saveStoredWidgetLayout({ position: this.createStoredPosition(linkedPosition.left, linkedPosition.top, toggleSize.width, toggleSize.height) });
        };

        app.persistWidgetTogglePosition = function () {
            if (!this.widgetToggleButtonElement || !config.widget.persistLayout) {
                return;
            }

            var togglePosition = this.getElementPosition(this.widgetToggleButtonElement);
            var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
            this.saveStoredWidgetLayout({ position: this.createStoredPosition(togglePosition.left, togglePosition.top, toggleSize.width, toggleSize.height) });
        };

        app.persistWidgetPanelSize = function () {
            if (!this.widgetContainerElement || !config.widget.enableResizing || !config.widget.persistLayout) {
                return;
            }

            var defaultSize = this.getWidgetDefaultSize();
            var currentSize = this.getElementSize(this.widgetContainerElement, defaultSize.width, defaultSize.height);

            this.saveStoredWidgetLayout({
                panel: {
                    width: Math.abs(currentSize.width - defaultSize.width) <= 1 ? null : currentSize.width,
                    height: Math.abs(currentSize.height - defaultSize.height) <= 1 ? null : currentSize.height
                }
            });
        };

        app.syncTogglePositionToPanel = function (persistLayout) {
            if (persistLayout === undefined) {
                persistLayout = true;
            }

            if (!this.widgetContainerElement || !this.widgetToggleButtonElement) {
                return;
            }

            var panelDefaultSize = this.getWidgetDefaultSize();
            var panelSize = this.getElementSize(this.widgetContainerElement, panelDefaultSize.width, panelDefaultSize.height);
            var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
            var panelPosition = this.getElementPosition(this.widgetContainerElement);
            var linkedPosition = this.clampWidgetPosition(
                panelPosition.left + panelSize.width - toggleSize.width,
                panelPosition.top + panelSize.height + this.getWidgetToggleGap(),
                toggleSize.width,
                toggleSize.height);

            this.applyAbsolutePosition(this.widgetToggleButtonElement, linkedPosition.left, linkedPosition.top);

            if (persistLayout && config.widget.persistLayout) {
                this.persistWidgetTogglePosition();
            }
        };

        app.syncPanelPositionToToggle = function (persistLayout) {
            if (persistLayout === undefined) {
                persistLayout = true;
            }

            if (!this.widgetContainerElement || !this.widgetToggleButtonElement) {
                return;
            }

            var panelDefaultSize = this.getWidgetDefaultSize();
            var panelSize = this.getElementSize(this.widgetContainerElement, panelDefaultSize.width, panelDefaultSize.height);
            var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
            var togglePosition = this.getElementPosition(this.widgetToggleButtonElement);
            var linkedPosition = this.clampWidgetPosition(
                togglePosition.left + toggleSize.width - panelSize.width,
                togglePosition.top - panelSize.height - this.getWidgetToggleGap(),
                panelSize.width,
                panelSize.height);

            this.applyAbsolutePosition(this.widgetContainerElement, linkedPosition.left, linkedPosition.top);

            if (persistLayout && config.widget.persistLayout) {
                this.persistWidgetPanelPosition();
            }
        };

        app.updateWidgetResetSizeButtonVisibility = function () {
            if (!this.widgetResetSizeButtonElement) {
                return;
            }

            if (!config.widget.enableResizing || !this.widgetContainerElement) {
                this.widgetResetSizeButtonElement.classList.add('d-none');
                return;
            }

            var defaultSize = this.getWidgetDefaultSize();
            var currentSize = this.getElementSize(this.widgetContainerElement, defaultSize.width, defaultSize.height);
            var isResized =
                Math.abs(currentSize.width - defaultSize.width) > 1 ||
                Math.abs(currentSize.height - defaultSize.height) > 1 ||
                !!this.widgetContainerElement.style.width ||
                !!this.widgetContainerElement.style.height;

            this.widgetResetSizeButtonElement.classList.toggle('d-none', !isResized);
        };

        app.resetWidgetSize = function () {
            if (!this.widgetContainerElement || !config.widget.enableResizing) {
                return;
            }

            this.widgetContainerElement.style.removeProperty('width');
            this.widgetContainerElement.style.removeProperty('height');
            this.persistWidgetPanelSize();
            this.constrainWidgetElementsToViewport();
            this.updateWidgetResetSizeButtonVisibility();
        };

        app.restoreWidgetLayout = function () {
            var storedLayout = this.getStoredWidgetLayout();

            if (this.widgetContainerElement && config.widget.enableResizing) {
                if (Number.isFinite(storedLayout.panel && storedLayout.panel.width)) {
                    this.widgetContainerElement.style.width = storedLayout.panel.width + 'px';
                }
                else {
                    this.widgetContainerElement.style.removeProperty('width');
                }

                if (Number.isFinite(storedLayout.panel && storedLayout.panel.height)) {
                    this.widgetContainerElement.style.height = storedLayout.panel.height + 'px';
                }
                else {
                    this.widgetContainerElement.style.removeProperty('height');
                }
            }

            var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
            var storedTogglePosition = this.resolveStoredPosition(storedLayout.position, toggleSize.width, toggleSize.height);
            if (this.widgetToggleButtonElement && config.widget.enableDragging && storedTogglePosition) {
                this.applyAbsolutePosition(this.widgetToggleButtonElement, storedTogglePosition.left, storedTogglePosition.top);
                this.syncPanelPositionToToggle(false);
            }
            else if (this.widgetToggleButtonElement && config.widget.enableDragging &&
                Number.isFinite(storedLayout.toggle && storedLayout.toggle.left) &&
                Number.isFinite(storedLayout.toggle && storedLayout.toggle.top)) {
                this.applyAbsolutePosition(this.widgetToggleButtonElement, storedLayout.toggle.left, storedLayout.toggle.top);
                this.syncPanelPositionToToggle(false);
            }
            else if (this.widgetContainerElement && config.widget.enableDragging &&
                Number.isFinite(storedLayout.panel && storedLayout.panel.left) &&
                Number.isFinite(storedLayout.panel && storedLayout.panel.top)) {
                this.applyAbsolutePosition(this.widgetContainerElement, storedLayout.panel.left, storedLayout.panel.top);
                this.syncTogglePositionToPanel(false);
            }

            this.constrainWidgetElementsToViewport();
            this.updateWidgetResetSizeButtonVisibility();
        };

        app.attachDraggableWidgetElement = function (element, handle, layoutKey, suppressClickOnDrag) {
            if (!element || !handle || !config.widget.enableDragging) {
                return;
            }

            var activePointerId = null;
            var startX = 0;
            var startY = 0;
            var startLeft = 0;
            var startTop = 0;
            var dragged = false;
            var dragThreshold = 4;
            var interactiveSelector = 'button, a, input, textarea, select, option, label';
            var self = this;

            function stopDragging(event) {
                if (activePointerId === null) {
                    return;
                }

                if (event && event.pointerId !== undefined && event.pointerId !== activePointerId) {
                    return;
                }

                document.removeEventListener('pointermove', onPointerMove);
                document.removeEventListener('pointerup', stopDragging);
                document.removeEventListener('pointercancel', stopDragging);
                element.classList.remove('ai-chat-widget-dragging');
                activePointerId = null;

                if (!dragged) {
                    return;
                }

                if (layoutKey === 'panel') {
                    self.syncTogglePositionToPanel(false);
                    self.persistWidgetPanelPosition();
                }
                else if (layoutKey === 'toggle') {
                    self.syncPanelPositionToToggle(false);
                    self.persistWidgetTogglePosition();
                }

                if (config.widget.persistLayout) {
                    self.persistWidgetPanelPosition();
                    self.persistWidgetTogglePosition();
                }

                if (suppressClickOnDrag) {
                    element.dataset.dragSuppressClick = 'true';
                    window.setTimeout(function () {
                        if (element.dataset.dragSuppressClick === 'true') {
                            element.dataset.dragSuppressClick = 'false';
                        }
                    }, 0);
                }
            }

            function onPointerMove(event) {
                if (activePointerId === null || event.pointerId !== activePointerId) {
                    return;
                }

                var deltaX = event.clientX - startX;
                var deltaY = event.clientY - startY;

                if (!dragged && Math.hypot(deltaX, deltaY) < dragThreshold) {
                    return;
                }

                dragged = true;

                var defaultSize = self.getWidgetDefaultSize();
                var currentSize = self.getElementSize(
                    element,
                    layoutKey === 'panel' ? defaultSize.width : 52,
                    layoutKey === 'panel' ? defaultSize.height : 52);
                var nextPosition = self.clampWidgetPosition(startLeft + deltaX, startTop + deltaY, currentSize.width, currentSize.height);

                self.applyAbsolutePosition(element, nextPosition.left, nextPosition.top);

                if (layoutKey === 'panel') {
                    self.syncTogglePositionToPanel(false);
                }
                else if (layoutKey === 'toggle') {
                    self.syncPanelPositionToToggle(false);
                }
            }

            handle.addEventListener('pointerdown', function (event) {
                if (event.button !== 0) {
                    return;
                }

                if (layoutKey === 'panel' && event.target.closest(interactiveSelector)) {
                    return;
                }

                var rect = element.getBoundingClientRect();
                startX = event.clientX;
                startY = event.clientY;
                startLeft = rect.left;
                startTop = rect.top;
                dragged = false;
                activePointerId = event.pointerId;
                element.classList.add('ai-chat-widget-dragging');

                if (handle.setPointerCapture) {
                    handle.setPointerCapture(event.pointerId);
                }

                document.addEventListener('pointermove', onPointerMove);
                document.addEventListener('pointerup', stopDragging);
                document.addEventListener('pointercancel', stopDragging);
                event.preventDefault();
            });
        };

        app.constrainWidgetElementsToViewport = function () {
            if (this.widgetContainerElement && this.widgetContainerElement.style.left && this.isWidgetPanelVisible()) {
                var panelDefaultSize = this.getWidgetDefaultSize();
                var panelSize = this.getElementSize(this.widgetContainerElement, panelDefaultSize.width, panelDefaultSize.height);
                var panelPosition = this.getElementPosition(this.widgetContainerElement);
                var clampedPanel = this.clampWidgetPosition(panelPosition.left, panelPosition.top, panelSize.width, panelSize.height);

                this.applyAbsolutePosition(this.widgetContainerElement, clampedPanel.left, clampedPanel.top);
                this.syncTogglePositionToPanel(false);

                if (config.widget.persistLayout) {
                    this.persistWidgetPanelPosition();
                    this.persistWidgetTogglePosition();
                }
            }
            else if (this.widgetToggleButtonElement && this.widgetToggleButtonElement.style.left) {
                var toggleSize = this.getElementSize(this.widgetToggleButtonElement, 52, 52);
                var togglePosition = this.getElementPosition(this.widgetToggleButtonElement);
                var clampedToggle = this.clampWidgetPosition(togglePosition.left, togglePosition.top, toggleSize.width, toggleSize.height);

                this.applyAbsolutePosition(this.widgetToggleButtonElement, clampedToggle.left, clampedToggle.top);
                this.syncPanelPositionToToggle(false);

                if (config.widget.persistLayout) {
                    this.persistWidgetTogglePosition();
                    this.persistWidgetPanelPosition();
                }
            }
        };

        app.showChatScreen = function () {
            if (!this.chatHistorySection) {
                return;
            }

            this.chatHistorySection.classList.remove('show');
        };
    }

    function initialize(app, config) {
        if (!app || app.widgetIsInitialized) {
            return;
        }

        if (!config.widget.chatWidgetContainer) {
            console.error('The widget chatWidgetContainer is required.');
            return;
        }

        if (!config.widget.chatWidgetStateName) {
            console.error('The widget chatWidgetStateName is required.');
            return;
        }

        var chatWidgetContainer = document.querySelector(config.widget.chatWidgetContainer);
        if (!chatWidgetContainer) {
            return;
        }

        if (config.widget.chatHistorySection) {
            app.chatHistorySection = document.querySelector(config.widget.chatHistorySection);
        }

            app.chatWidgetStateName = config.widget.chatWidgetStateName;
            app.chatWidgetStateSession = config.widget.chatWidgetStateName + 'Session';
            app.chatWidgetStateDocuments = config.widget.chatWidgetStateName + 'Documents';
            app.chatWidgetLayoutKey = config.widget.chatWidgetStateName + 'Layout';
            app.widgetContainerElement = chatWidgetContainer;
        app.widgetToggleButtonElement = config.widget.toggleButtonSelector ? document.querySelector(config.widget.toggleButtonSelector) : null;
        app.widgetResetSizeButtonElement = config.widget.resetSizeButtonSelector ? document.querySelector(config.widget.resetSizeButtonSelector) : null;
        app.widgetDefaultWidth = parsePixelValue(config.widget.defaultWidth) || parsePixelValue(window.getComputedStyle(chatWidgetContainer).width) || 380;
            app.widgetDefaultHeight = parsePixelValue(config.widget.defaultHeight) || parsePixelValue(window.getComputedStyle(chatWidgetContainer).height) || 520;
            app.widgetIsInitialized = true;
            app.clearStoredWidgetDocuments();
            app.documents = [];

            if (config.widget.enableResizing) {
            chatWidgetContainer.classList.add('ai-chat-widget-resizable');
            chatWidgetContainer.style.minWidth = (parsePixelValue(config.widget.minWidth) || 320) + 'px';
            chatWidgetContainer.style.minHeight = (parsePixelValue(config.widget.minHeight) || 420) + 'px';

            if (typeof ResizeObserver !== 'undefined') {
                app.widgetResizeObserver = new ResizeObserver(function () {
                    app.persistWidgetPanelSize();
                    app.constrainWidgetElementsToViewport();
                    app.updateWidgetResetSizeButtonVisibility();
                });

                app.widgetResizeObserver.observe(chatWidgetContainer);
            }
        }

        var dragHandleSelector = config.widget.dragHandleSelector || '.ai-chat-widget-header';
        var dragHandle = chatWidgetContainer.querySelector(dragHandleSelector);

        if (config.widget.enableDragging && dragHandle) {
            dragHandle.classList.add('ai-chat-widget-drag-handle');
            chatWidgetContainer.classList.add('ai-chat-widget-draggable');
            app.attachDraggableWidgetElement(chatWidgetContainer, dragHandle, 'panel', false);
        }

        if (config.widget.enableDragging && app.widgetToggleButtonElement) {
            app.widgetToggleButtonElement.classList.add('ai-chat-widget-draggable');
            app.attachDraggableWidgetElement(app.widgetToggleButtonElement, app.widgetToggleButtonElement, 'toggle', true);
        }

        if (app.widgetResetSizeButtonElement) {
            app.widgetResetSizeButtonElement.addEventListener('click', function (event) {
                event.preventDefault();
                app.resetWidgetSize();
            });
        }

            app.restoreWidgetLayout();

            if (!app.widgetViewportResizeHandler) {
                app.widgetViewportResizeHandler = function () {
                    if (config.widget.persistLayout) {
                        app.restoreWidgetLayout();
                    } else {
                        app.constrainWidgetElementsToViewport();
                    }

                    app.updateWidgetResetSizeButtonVisibility();
                };

            window.addEventListener('resize', app.widgetViewportResizeHandler);
        }

        app.reloadCurrentSession();

        if (config.widget.showHistoryButton && app.chatHistorySection) {
            var showHistoryButton = document.querySelector(config.widget.showHistoryButton);
            if (showHistoryButton) {
                showHistoryButton.addEventListener('click', function () {
                    app.chatHistorySection.classList.toggle('show');
                });
            }

            if (config.widget.closeHistoryButton) {
                var closeHistoryButton = document.querySelector(config.widget.closeHistoryButton);
                if (closeHistoryButton) {
                    closeHistoryButton.addEventListener('click', function () {
                        app.showChatScreen();
                    });
                }
            }
        }

        if (config.widget.newChatButton) {
            var newChatButton = document.querySelector(config.widget.newChatButton);
            if (newChatButton) {
                newChatButton.addEventListener('click', function () {
                    app.resetSession();
                    app.showChatScreen();
                });
            }
        }
    }

    function resolveSessionId(app) {
        if (!app || !app.widgetIsInitialized) {
            return null;
        }

        return localStorage.getItem(app.chatWidgetStateSession);
    }

    function onSessionInitialized(app, sessionId) {
        if (app && app.widgetIsInitialized) {
            localStorage.setItem(app.chatWidgetStateSession, sessionId);
        }
    }

    function onSessionReset(app) {
        if (app && app.widgetIsInitialized) {
            localStorage.removeItem(app.chatWidgetStateSession);
            app.clearStoredWidgetDocuments();
        }
    }

    function onDocumentsChanged(app, documents) {
        if (app && app.widgetIsInitialized) {
            app.saveStoredWidgetDocuments(documents);
        }
    }

    function handleReceiveError(app) {
        if (app && app.widgetIsInitialized && !app.isSessionStarted && !app._attemptedSessionRecovery) {
            app._attemptedSessionRecovery = true;
            localStorage.removeItem(app.chatWidgetStateSession);
            app.clearStoredWidgetDocuments();
            app.startNewSession();
        }
    }

    function dispose(app) {
        if (!app) {
            return;
        }

        if (app.widgetResizeObserver) {
            app.widgetResizeObserver.disconnect();
            app.widgetResizeObserver = null;
        }

        if (app.widgetViewportResizeHandler) {
            window.removeEventListener('resize', app.widgetViewportResizeHandler);
            app.widgetViewportResizeHandler = null;
        }
    }

    return {
        attach: attach,
        initialize: initialize,
        onMounted: initialize,
        resolveSessionId: resolveSessionId,
        onSessionInitialized: onSessionInitialized,
        onSessionReset: onSessionReset,
        onDocumentsChanged: onDocumentsChanged,
        handleReceiveError: handleReceiveError,
        dispose: dispose,
        onBeforeUnmount: dispose
    };
}();

window.coreAIChatWidgetManager = window.coreAIChatWidgetManager || function () {
    function getAttributeValue(element, attributeName) {
        var value = element.getAttribute(attributeName);
        return value === null || value === '' ? null : value;
    }

    function parseBooleanAttributeValue(value) {
        if (value === null || value === undefined) {
            return null;
        }

        if (typeof value === 'boolean') {
            return value;
        }

        var normalized = String(value).trim().toLowerCase();
        if (normalized === 'true') {
            return true;
        }

        if (normalized === 'false') {
            return false;
        }

        return null;
    }

    function parseJsonAttribute(element, attributeName, description) {
        var rawValue = getAttributeValue(element, attributeName);
        if (!rawValue) {
            return null;
        }

        try {
            return JSON.parse(rawValue);
        }
        catch (error) {
            console.error('Failed to parse ' + description + ' JSON.', error);
            return null;
        }
    }

    function buildOptionsFromDataAttributes(element) {
        var widgetContainerSelector = getAttributeValue(element, 'data-coreai-chat-widget-container-selector');
        if (!widgetContainerSelector) {
            return null;
        }

        var chatConfig = null;
        if (window.coreAIChatManager && typeof window.coreAIChatManager.buildConfigFromElement === 'function') {
            chatConfig = window.coreAIChatManager.buildConfigFromElement(element, { allowWidgetHost: true });
        }

        var profileId = getAttributeValue(element, 'data-coreai-chat-widget-profile-id');
        var profileName = getAttributeValue(element, 'data-coreai-chat-widget-profile-name');
        var profileDisplayText = getAttributeValue(element, 'data-coreai-chat-widget-profile-display-text');
        var profileWelcomeMessage = getAttributeValue(element, 'data-coreai-chat-widget-profile-welcome-message');
        var profileInitialPrompt = getAttributeValue(element, 'data-coreai-chat-widget-profile-initial-prompt');
        var profileChatMode = getAttributeValue(element, 'data-coreai-chat-widget-profile-chat-mode');
        var profileTtsVoiceName = getAttributeValue(element, 'data-coreai-chat-widget-profile-tts-voice-name');
        var profileMetricsEnabled = parseBooleanAttributeValue(getAttributeValue(element, 'data-coreai-chat-widget-profile-enable-session-metrics'));
        var profileSessionDocuments = parseBooleanAttributeValue(getAttributeValue(element, 'data-coreai-chat-widget-profile-allow-session-documents'));
        var profile = null;

        if (profileId || profileName || profileDisplayText || profileWelcomeMessage || profileChatMode || profileTtsVoiceName || profileMetricsEnabled !== null || profileSessionDocuments !== null) {
            profile = {
                id: profileId,
                name: profileName,
                displayText: profileDisplayText,
                welcomeMessage: profileWelcomeMessage,
                initialPrompt: profileInitialPrompt,
                chatMode: profileChatMode,
                ttsVoiceName: profileTtsVoiceName,
                enableSessionMetrics: profileMetricsEnabled === true,
                allowSessionDocuments: profileSessionDocuments === true
            };
        }

        var enableDragging = parseBooleanAttributeValue(getAttributeValue(element, 'data-coreai-chat-widget-enable-dragging'));
        var enableResizing = parseBooleanAttributeValue(getAttributeValue(element, 'data-coreai-chat-widget-enable-resizing'));
        var persistLayout = parseBooleanAttributeValue(getAttributeValue(element, 'data-coreai-chat-widget-persist-layout'));

        return {
            shellSelector: getAttributeValue(element, 'data-coreai-chat-widget-shell-selector'),
            widgetContainerSelector: widgetContainerSelector,
            toggleButtonSelector: getAttributeValue(element, 'data-coreai-chat-widget-toggle-button-selector'),
            closeButtonSelector: getAttributeValue(element, 'data-coreai-chat-widget-close-button-selector'),
            inputSelector: getAttributeValue(element, 'data-coreai-chat-widget-input-selector'),
            messageTemplateSelector: getAttributeValue(element, 'data-coreai-chat-widget-message-template-selector'),
            indicatorTemplateSelector: getAttributeValue(element, 'data-coreai-chat-widget-indicator-template-selector'),
            profile: profile,
            widgetStateName: getAttributeValue(element, 'data-coreai-chat-widget-state-name'),
            openStateValue: getAttributeValue(element, 'data-coreai-chat-widget-open-state-value'),
            closedStateValue: getAttributeValue(element, 'data-coreai-chat-widget-closed-state-value'),
            openIconHtml: getAttributeValue(element, 'data-coreai-chat-widget-open-icon-html'),
            closedIconHtml: getAttributeValue(element, 'data-coreai-chat-widget-closed-icon-html'),
            chatConfig: chatConfig ? Object.assign({}, chatConfig, {
                initialPrompt: profileInitialPrompt || chatConfig.initialPrompt,
                widget: Object.assign({}, chatConfig.widget || {}, {
                    chatWidgetContainer: widgetContainerSelector,
                    chatWidgetStateName: getAttributeValue(element, 'data-coreai-chat-widget-state-name'),
                    newChatButton: getAttributeValue(element, 'data-coreai-chat-widget-new-chat-button-selector'),
                    toggleButtonSelector: getAttributeValue(element, 'data-coreai-chat-widget-toggle-button-selector'),
                    resetSizeButtonSelector: getAttributeValue(element, 'data-coreai-chat-widget-reset-size-button-selector'),
                    dragHandleSelector: getAttributeValue(element, 'data-coreai-chat-widget-drag-handle-selector'),
                    enableDragging: enableDragging === null ? undefined : enableDragging,
                    enableResizing: enableResizing === null ? undefined : enableResizing,
                    persistLayout: persistLayout === null ? undefined : persistLayout,
                })
            }) : null
        };
    }

    function initialize(options) {
        if (!options) {
            return null;
        }

        var chatConfig = options.chatConfig;
        if (!chatConfig && options.configElementSelector) {
            var configElement = document.querySelector(options.configElementSelector);
            chatConfig = configElement ? parseJsonAttribute(configElement, 'data-config', 'AI chat widget config') : null;
        }

        if (!chatConfig) {
            return null;
        }

        if (options.messageTemplateSelector) {
            var messageTemplate = document.querySelector(options.messageTemplateSelector);
            if (messageTemplate) {
                chatConfig.messageTemplate = messageTemplate.innerHTML;
            }
        }

        if (options.indicatorTemplateSelector) {
            var indicatorTemplate = document.querySelector(options.indicatorTemplateSelector);
            if (indicatorTemplate) {
                chatConfig.indicatorTemplate = indicatorTemplate.innerHTML;
            }
        }

        var shell = document.querySelector(options.shellSelector);
        var widgetContainer = document.querySelector(options.widgetContainerSelector);
        var toggleButton = document.querySelector(options.toggleButtonSelector);
        var closeButton = document.querySelector(options.closeButtonSelector);
        var profileInput = options.inputSelector ? document.querySelector(options.inputSelector) : null;
        var widgetStateName = options.widgetStateName || chatConfig.widget.chatWidgetStateName;
        var widgetOpenStateKey = options.widgetOpenStateKey || (widgetStateName + 'Open');
        var widgetLayoutKey = widgetStateName + 'Layout';
        var openStateValue = options.openStateValue || 'open';
        var closedStateValue = options.closedStateValue || 'closed';

        if (profileInput && options.profile && options.profile.id) {
            profileInput.setAttribute('data-profile-id', options.profile.id);
        }

        try {
            var storedLayout = localStorage.getItem(widgetLayoutKey);
            var layout = storedLayout ? JSON.parse(storedLayout) || {} : {};
            var position = layout.position || {};
            var panelLayout = layout.panel || {};
            var toggleLeft = Number(position.left);
            var toggleTop = Number(position.top);
            var isOpen = localStorage.getItem(widgetOpenStateKey) === openStateValue;
            var viewportPadding = 8;

            if (shell) {
                shell.dataset.deferReveal = isOpen ? 'true' : 'false';
                shell.dataset.initialOpen = isOpen ? 'true' : 'false';
            }

            if (widgetContainer && toggleButton) {
                var toggleSize = 52;
                var panelWidth = Number.isFinite(Number(panelLayout.width))
                    ? Number(panelLayout.width)
                    : Math.round(parseFloat(window.getComputedStyle(widgetContainer).width) || 380);
                var panelHeight = Number.isFinite(Number(panelLayout.height))
                    ? Number(panelLayout.height)
                    : Math.round(parseFloat(window.getComputedStyle(widgetContainer).height) || 520);
                var maxLeft = Math.max(viewportPadding, window.innerWidth - toggleSize - viewportPadding);
                var maxTop = Math.max(viewportPadding, window.innerHeight - toggleSize - viewportPadding);
                if (Number.isFinite(Number(position.leftRatio))) {
                    toggleLeft = viewportPadding + Math.max(0, maxLeft - viewportPadding) * Number(position.leftRatio);
                }
                if (Number.isFinite(Number(position.topRatio))) {
                    toggleTop = viewportPadding + Math.max(0, maxTop - viewportPadding) * Number(position.topRatio);
                }
                if (Number.isFinite(toggleLeft) && Number.isFinite(toggleTop)) {
                    toggleLeft = Math.round(clampWidgetValue(toggleLeft, viewportPadding, maxLeft));
                    toggleTop = Math.round(clampWidgetValue(toggleTop, viewportPadding, maxTop));
                }

                if (Number.isFinite(toggleLeft) && Number.isFinite(toggleTop)) {
                toggleButton.style.left = toggleLeft + 'px';
                toggleButton.style.top = toggleTop + 'px';
                toggleButton.style.right = 'auto';
                toggleButton.style.bottom = 'auto';

                    var toggleGap = 8;
                widgetContainer.style.left = (toggleLeft + toggleSize - panelWidth) + 'px';
                widgetContainer.style.top = (toggleTop - panelHeight - toggleGap) + 'px';
                widgetContainer.style.right = 'auto';
                widgetContainer.style.bottom = 'auto';
                }
            }

            if (widgetContainer) {
                widgetContainer.classList.remove('open');
                widgetContainer.style.display = 'none';
                widgetContainer.setAttribute('aria-hidden', 'true');
            }

            if (toggleButton) {
                toggleButton.innerHTML = isOpen ? options.openIconHtml : options.closedIconHtml;
            }
        }
        catch (error) {
            console.warn('Failed to restore widget layout before initialization.', error);
        }
        finally {
            if (shell && shell.dataset.deferReveal !== 'true') {
                shell.style.visibility = '';
            }
        }

        var widgetApp = window.coreAIChatManager.initialize(chatConfig);
        if (options.applySessionProfilePatch !== false && window.crestAppsAIChat && window.crestAppsAIChat.patchSessionProfileSync) {
            window.crestAppsAIChat.patchSessionProfileSync(widgetApp);
        }

        function revealShell() {
            if (!shell) {
                return;
            }

            shell.style.visibility = '';
            shell.dataset.deferReveal = 'false';
        }

        function syncOpenPanelPosition() {
            if (!widgetApp || typeof widgetApp.syncPanelPositionToToggle !== 'function') {
                return;
            }

            widgetApp.syncPanelPositionToToggle(false);
        }

        function updateTtsPlaybackButtons() {
            if (!widgetContainer) {
                return;
            }

            var buttons = widgetContainer.querySelectorAll('[data-tts-message-index]');
            buttons.forEach(function (button) {
                var buttonIndex = Number(button.getAttribute('data-tts-message-index'));
                var isPlaying = buttonIndex === widgetApp.ttsPlayingMessageIndex;
                button.classList.toggle('tts-playing', isPlaying);
                button.setAttribute('title', isPlaying ? 'Pause audio' : 'Read aloud');
            });
        }

        function queueTtsPlaybackButtonUpdate() {
            requestAnimationFrame(updateTtsPlaybackButtons);
        }

        function revealShellWhenStable(initialOpen) {
            if (!shell || shell.dataset.deferReveal !== 'true' || !initialOpen) {
                revealShell();
                return;
            }

            var hasRevealed = false;
            var resizeObserver = null;

            function finalizeReveal() {
                if (hasRevealed) {
                    return;
                }

                hasRevealed = true;

                if (resizeObserver) {
                    resizeObserver.disconnect();
                }

                requestAnimationFrame(function () {
                    syncOpenPanelPosition();
                    requestAnimationFrame(function () {
                        revealShell();
                    });
                });
            }

            if (typeof ResizeObserver === 'undefined') {
                window.setTimeout(finalizeReveal, 0);
                return;
            }

            var lastWidth = 0;
            var lastHeight = 0;
            var stablePasses = 0;

            resizeObserver = new ResizeObserver(function (entries) {
                var entry = entries && entries[0];
                if (!entry) {
                    return;
                }

                var width = Math.round(entry.contentRect.width);
                var height = Math.round(entry.contentRect.height);
                if (!width || !height) {
                    return;
                }

                syncOpenPanelPosition();

                if (width === lastWidth && height === lastHeight) {
                    stablePasses++;
                }
                else {
                    lastWidth = width;
                    lastHeight = height;
                    stablePasses = 0;
                }

                if (stablePasses >= 1) {
                    finalizeReveal();
                }
            });

            resizeObserver.observe(widgetContainer);
            window.setTimeout(finalizeReveal, 150);
        }

        function setWidgetOpen(isOpen) {
            if (widgetApp) {
                var isCurrentlyOpen = widgetContainer.classList.contains('open');
                if (isOpen && !isCurrentlyOpen && typeof widgetApp.syncPanelPositionToToggle === 'function') {
                    widgetApp.syncPanelPositionToToggle();
                }
                else if (!isOpen && isCurrentlyOpen && typeof widgetApp.syncTogglePositionToPanel === 'function') {
                    widgetApp.syncTogglePositionToPanel();
                }
            }

            widgetContainer.classList.toggle('open', isOpen);
            widgetContainer.style.display = isOpen ? 'flex' : 'none';
            widgetContainer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            toggleButton.innerHTML = isOpen ? options.openIconHtml : options.closedIconHtml;
            localStorage.setItem(widgetOpenStateKey, isOpen ? openStateValue : closedStateValue);

            if (isOpen && typeof window.renderPendingCharts === 'function') {
                setTimeout(function () { window.renderPendingCharts(); }, 100);
            }
        }

        var initialOpen = shell && shell.dataset.initialOpen === 'true';
        setWidgetOpen(initialOpen);
        revealShellWhenStable(initialOpen);

        if (widgetApp && typeof widgetApp.$watch === 'function') {
            widgetApp.$watch('ttsPlayingMessageIndex', function () {
                queueTtsPlaybackButtonUpdate();
            });
        }

        queueTtsPlaybackButtonUpdate();

        if (toggleButton) {
            toggleButton.addEventListener('click', function () {
                if (toggleButton.dataset.dragSuppressClick === 'true') {
                    toggleButton.dataset.dragSuppressClick = 'false';
                    return;
                }

                setWidgetOpen(!widgetContainer.classList.contains('open'));
            });
        }

        if (closeButton) {
            closeButton.addEventListener('click', function () {
                setWidgetOpen(false);
            });
        }

        return widgetApp;
    }

    function initializeFromElement(element) {
        if (!element || element.dataset.coreAiChatWidgetInitialized === 'true') {
            return element ? element.__coreAIChatWidgetApp || null : null;
        }

        var jsonOptions = parseJsonAttribute(element, 'data-coreai-chat-widget-config', 'CoreAI chat widget config');
        var attributeOptions = buildOptionsFromDataAttributes(element);
        if (!jsonOptions && !attributeOptions) {
            return null;
        }

        var options = Object.assign({}, jsonOptions || {}, attributeOptions || {});

        var widgetApp = initialize(options);
        if (!widgetApp) {
            return null;
        }

        element.dataset.coreAiChatWidgetInitialized = 'true';
        element.__coreAIChatWidgetApp = widgetApp;

        return widgetApp;
    }

    function scanForAutoInitialization(root) {
        if (!root || typeof root.querySelectorAll !== 'function') {
            return;
        }

        if (typeof root.matches === 'function' && root.matches('[data-coreai-chat-widget-config],[data-coreai-chat-widget-container-selector]')) {
            initializeFromElement(root);
        }

        root.querySelectorAll('[data-coreai-chat-widget-config],[data-coreai-chat-widget-container-selector]').forEach(initializeFromElement);
    }

    function startAutoInitialization() {
        scanForAutoInitialization(document);

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node && node.nodeType === 1) {
                        scanForAutoInitialization(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startAutoInitialization, { once: true });
    } else {
        startAutoInitialization();
    }

    return {
        initialize: initialize,
        initializeFromElement: initializeFromElement,
    };
}();
